function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.992 6.227h8.95L5.86 10.226l.741.726 5.346-5.238L6.601.476l-.741.725 4.082 4H.992z",
  fillRule: "evenodd"
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11,
    viewBox: "0 0 12 11",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjExIiB2aWV3Qm94PSIwIDAgMTIgMTEiIHdpZHRoPSIxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMTEuOTQ4IDUuMjAxaC04Ljk1bDQuMDgyLTMuOTk5LS43NDEtLjcyNi01LjM0NiA1LjIzOCA1LjM0NiA1LjIzOC43NDEtLjcyNS00LjA4Mi00aDguOTV6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAtMSAxMi45NCAxMS40MjgpIi8+PC9zdmc+";
export { SvgArrow as ReactComponent };